import { render, staticRenderFns } from "./DisplayAttachment.vue?vue&type=template&id=0500e762"
import script from "./DisplayAttachment.vue?vue&type=script&lang=ts"
export * from "./DisplayAttachment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports